import { render, staticRenderFns } from "./SaitenResultUpload.vue?vue&type=template&id=d38d18f4&"
import script from "./SaitenResultUpload.vue?vue&type=script&lang=ts&"
export * from "./SaitenResultUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports